export default {
  headerContent: {
    title: 'Ray Sigorta Seyahat Sağlık Sigortası Ücretleri',
    slogan: "Seyahat Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'SEYAHAT SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Ray Sigorta Seyahat Sağlık Sigortası',
    description: {
      title: 'Ray Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'Seyahat sağlık sigortası, planladığınız yolculukları güvence altına alır. Tatile çıkmadan önce bir şeylerin planlandığı gibi gitmemesi göz önünde bulundurularak, seyahat sigortası satın almaya karar vermek, en akıllı finansal kararlarınızdan biri olabilir. ',
        'Seyahat sigortası her zaman yapacağınız seyahatler için tavsiye edilir ve beklenmedik bir acil durumda çok önemli destek sağlar. Ray Sigorta kapsamında seyahatlerinizi güvence altına alabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Ray Sigorta Seyahat Sağlık Sigortası Planları Nelerdir?',
      content: [
        {
          paragraph: 'Ray Sigorta müşterilerine özel 3 farklı seyahat sağlık sigortası planı sunmaktadır:',
          subList: [
            'Tripplus Yurt İçi Seyahat Sağlık Sigortası',
            'Tripplus Yurt Dışı Seyahat Sağlık Sigortası',
            'Türkiye Vize Seyahat Sigortası'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Seyahat Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Ray Sigorta Seyahat Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
